// components/RedirectIfAuthenticated.tsx
import { LOCAL_STORAGE_KEYS } from '@command-center-app/constants/common.const';
import { Navigate } from 'react-router-dom';

const RedirectIfAuthenticated = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.JWT_TOKEN);

  return token ? <Navigate to="/" replace /> : <>{children}</>;
};

export default RedirectIfAuthenticated;
